export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'title',
  },
  {
    title: '副标题',
    dataIndex: 'title_sub',
  },
  {
    title: '消息类型',
    customRender: (text, record)=>{
      return record.type===0?'系统消息':'清单消息';
    },
  },
  {
    title: '接收企业',
    dataIndex: 'qichacha_name',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'未审核':'已审核';
    },
  },
  {
    title: '发布状态',
    customRender: (text, record)=>{
      return record.status_send===0?'未发布':'已发布';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'title',
    lable: '标题',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'title_sub',
    lable: '副标题',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'type',
    lable: '消息类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'company_type',
    lable: '企业类型',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'company_id',
    lable: '企业名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'jump_info',
    lable: '跳转信息',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
  {
    name: 'summary',
    lable: '消息内容',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },

];